interface ContactAvatarProps {
  name: string;
  size?: number;
}

/** Deterministic monogram tile for a contact — initials on a hue derived from
 *  the name, so the same contact always gets the same colour. Mirrors the
 *  letter-tile fallback HbsSiteIcon uses for logins, but for people not sites. */
export function ContactAvatar({ name, size = 34 }: ContactAvatarProps): JSX.Element {
  const trimmed = name.trim();
  const initials = trimmed
    ? trimmed
        .split(/\s+/)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase() ?? '')
        .join('')
    : '?';

  // Stable hue from the name (simple sum-of-char-codes → 0–359°).
  let hash = 0;
  for (let i = 0; i < trimmed.length; i++) hash = (hash + trimmed.charCodeAt(i)) % 360;

  return (
    <span
      aria-hidden="true"
      className="inline-flex items-center justify-center rounded-full font-semibold text-white select-none"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.4),
        backgroundColor: `hsl(${hash} 52% 45%)`,
      }}
    >
      {initials}
    </span>
  );
}
